import LevelBase from "./levelBase";
import { Empty, Exit, NPCharacter, Player } from "../objects";
import { translate } from "../../utils/localization";
import EasyStar from "easystarjs";
import UI from "../UI";
import { TICK_TIME } from "../../utils/constants";
import template from "lodash.template";

class Level11 extends LevelBase {
  constructor() {
    super();
    this.easystar = new EasyStar.js();
    this.name = "The fallen city";
    this.diamondsGoal = 14;
  }

  get id() {
    return this.constructor.key;
  }

  async connectToScene(scene) {
    await super.connectToScene(scene);

    if (this.unfinished) {
      // erase method to animate exit destruction after talk to dwarf
      this.destroyBlock = () => false;
    }

    // fisrt explosion
    scene.events.once("barre:explode", (el) => {
      // TICK COUNTER TO DIALOG
      this.setTickTimeout(lvl => lvl.showDialog2(), 5)
    });
  }

  onInteractWith(el) {
    super.onInteractWith(el);

    if (el.order === 0 && this.unfinished) {
      this.showDialog1();
    }

    if (el.order === 1 && this.unfinished) {
      this.showDialog3()
    }

    if (el.order === 2 && this.unfinished) {
      // move dwarf hidding it while travels
      const nextPos = { x: this.exit.position.x - 3, y: this.exit.position.y };
      this.leader.alien.alpha = 0;
      this.moveObject(this.leader, nextPos);
      setTimeout(() => {
        this.leader.alien.alpha = 1;

        // set up next trigger by proximity
        this.scene.events.on("player_moves", nextPos => {
          if (this.leader.testProximity(nextPos, 1, true)) {
            if(this.diamondsGoal <= this.collectedDiamonds) {
              this.clearPath()
              this.scene.events.off("player_moves")
            } else {
              // fall short of diamonds
              this.showDialog4()
            }
          }
        })
      }, 500);
      // -----
    }

    if (el.isClass(Exit)) {
      this.onComplete();
    }
  }

  showDialog1() {
    this.scene.events.once("dialogue:hidden", () => {
      // Path finder to exit for Dwarf
      const objectsAsKeys = this.objects.map((row) =>
        row.map((el) => (el.isClass(NPCharacter) || el.isClass(Empty) ? 0 : 1))
      );
      this.easystar.setGrid(objectsAsKeys);
      this.easystar.setAcceptableTiles([0]);

      // remove listener since dwarf moves by himself
      this.scene.events.off("player_moves");
      this.player.disconnect();

      this.easystar.enableDiagonals();
      this.easystar.findPath(
        this.leader.position.x,
        this.leader.position.y,
        1,
        10,
        (path) => {
          this.leader.leadingPath = path.slice(1);
          this.easystar.findPath(1, 10, 7, 18, (path) => {
            // iterate leadingPath and duplicate when it moves in diagonal
            const isDiagonal = (o, n) => o.x !== n.x && o.y !== n.y
            this.leader.leadingPath = [
              ...this.leader.leadingPath,
              ...path.slice(1),
            ].reduce((res, el, idx, src) => {
              if(src[idx-1]) {
                const prevEl = src[idx-1]
                if(isDiagonal(el, prevEl)) {
                  // repeats prev position
                  res.push(prevEl)
                }
              }
              res.push(el)
              return res
            },[])

            this.dwarfRun = true;
            this.moveDwarf();

            // TICK COUNTER TO RECONNECT PLAYER
            this.setTickTimeout(lvl => lvl.player.reconnect(), 4)
          });
          this.easystar.calculate();
        }
      );
      this.easystar.calculate();

      
    });
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary", "closeUp_Dwarf"],
      participantNames: ["Mary", "Doc"],
      conversation: [
        {
          who: "closeUp_Mary",
          text: [translate("level_11.dialog_1.mary_say_1")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_11.dialog_1.dwarf_say_1")],
        },
        {
          who: "closeUp_Mary",
          text: [translate("level_11.dialog_1.mary_say_2")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_11.dialog_1.dwarf_say_2")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_11.dialog_1.dwarf_say_3")],
        },
        {
          who: "closeUp_Mary",
          text: [translate("level_11.dialog_1.mary_say_3")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_11.dialog_1.dwarf_say_4")],
        },
      ],
    });
  }

  showDialog2() {
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary"],
      participantNames: ["Mary"],
      conversation: [
        {
          who: "closeUp_Mary",
          text: [translate("level_11.dialog_2.mary_say_1")],
        },
      ],
    });
  }
  showDialog3() {
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary", "closeUp_Dwarf"],
      participantNames: ["Mary", "Doc"],
      conversation: [
        {
          who: "closeUp_Dwarf",
          text: [translate("level_11.dialog_3.dwarf_say_1")],
        },
        {
          who: "closeUp_Mary",
          text: [translate("level_11.dialog_3.mary_say_1")],
        },
      ],
    });
  }

  showDialog4() {
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary", "closeUp_Dwarf"],
      participantNames: ["Mary", "Doc"],
      conversation: [
        {
          who: "closeUp_Dwarf",
          text: [template(translate("level_11.dialog_4.dwarf_say_1"))({ NUM: this.diamondsGoal })],
        },
      ],
    });
  }

  moveDwarf() {
    // hack to auto move dwarf
    if (this.dwarfRun) {
      if (!this.leader.leadingPath.length) {
        this.dwarfRun = false;
      }

      this.onNextTick(() => {
        // hack: giving the leader position itself it will always return true for isCloseEnough calc since is closer than 3 blocks away.
        this.leader.onPlayerMoves(this.leader.position);
        // this.leader.animIdle();
        this.moveDwarf();
      });
    } else {
      this.leader.animIdle();
    }
  }

  clearPath() {
    // anim dwarf and angel dismiss
    this.scene.tweens.add({
      targets: this.exit.block.alien,
      x: UI.tileToScreen(this.exit.position.x),
      duration: TICK_TIME * 2,
      onComplete: () => this.exit.block.alien.destroy(),
    });

    this.leader.leadingPath = [
      { x: this.leader.position.x + 1, y: this.leader.position.y },
      { x: this.leader.position.x + 1, y: this.leader.position.y },
      { x: this.leader.position.x + 2, y: this.leader.position.y },
      { x: this.leader.position.x + 2, y: this.leader.position.y },
      { x: this.leader.position.x + 3, y: this.leader.position.y },
      { x: this.leader.position.x + 3, y: this.leader.position.y },
    ];
    this.player.disconnect();
    this.dwarfRun = true;
    this.moveDwarfToExit();
  }

  moveDwarfToExit() {
    // hack to auto move dwarf
    if (this.dwarfRun) {
      if (this.leader.position.x < this.exit.position.x) {
        this.onNextTick(() => {
          this.leader.onPlayerMoves(this.leader.position);
          // this.leader.animIdle();
          this.moveDwarfToExit();
        });
      } else {
        this.onNextTick(() => {
          this.replaceByEmpty(this.leader)
        });
        // this.leader.animIdle();
        // auto pilot off
        this.player.reconnect();
      }
    }
  }

  onAddElement(el) {
    if (el.isClass(Player)) {
      el.power = 1;
      el.hasPickaxe = true;
    }

    if (el.isClass(NPCharacter)) {
      el.leadingPath = [];
    }

    if(el.isClass(Exit)) {
      this.exit = el
    }
  }
}

Level11.key = "level_11";
export default Level11;
